import Bus from '@/services/EventBus';

/**
 * @param {Object} store
 */
export default function (store) {
    // Called when the store is initialized
    store.subscribe((mutation, state) => {
        // Check if the mutation type is one of those that modify cart items
        if (
            [
                'cart/addProductVariantToCart',
                'cart/removeProductVariantFromCart',
                'cart/setProductVariantQuantity',
                'cart/setCartItems'
            ].includes(mutation.type)
        ) {
            // get campaign handle
            const { handle } = window?.SAILS_LOCALS?.campaign;
            // Update localStorage with the new state of cart items
            localStorage.setItem(`${handle}-cartItems`, JSON.stringify(state.cart.items));
            Bus.$emit(`${handle}-cartUpdated`);
        }
    });
}
